import { defineMessages } from 'react-intl';

const dictionary = defineMessages({
  'Colleagues.Content.Find.text': {
    id: 'Colleagues.Content.Find.text',
    defaultMessage: 'Find my colleague',
  },
  'Colleagues.Content.Find.status.free': {
    id: 'Colleagues.Content.Find.status.free',
    defaultMessage: 'Free from {start} to {end}',
  },
  'Colleagues.Content.Find.status.free.all': {
    id: 'Colleagues.Content.Find.status.freeall',
    defaultMessage: 'Free all the day',
  },
  'Colleagues.Content.Find.status.busy': {
    id: 'Colleagues.Content.Find.status.busy',
    defaultMessage: 'Busy from {start} to {end}',
  },
  'Colleagues.Content.Find.status.travel': {
    id: 'Colleagues.Content.Find.status.travel',
    defaultMessage: 'On a Travel/Holiday',
  },
  'Colleagues.Content.Find.status.absent': {
    id: 'Colleagues.Content.Find.status.absent',
    defaultMessage: 'Away / Not booked',
  },
  'Colleagues.Content.Book.text': {
    id: 'Colleagues.Content.Book.text',
    defaultMessage: 'Book same room',
  },
  'Colleagues.error.no-data': {
    id: 'Colleagues.error.no-data',
    defaultMessage: 'No data available',
  },
  'Colleagues.Content.Find.home_office': {
    id: 'Colleagues.Content.Find.home_office',
    defaultMessage: 'Home Office',
  },
  'Colleagues.Content.Find.building': {
    id: 'Colleagues.Content.Find.building',
    defaultMessage: 'Building',
  },
  'Colleagues.Content.Find.address': {
    id: 'Colleagues.Content.Find.address',
    defaultMessage: 'Address',
  },
  'Colleagues.Content.Find.floor': {
    id: 'Colleagues.Content.Find.floor',
    defaultMessage: 'Floor',
  },
  'Colleagues.Content.Find.area': {
    id: 'Colleagues.Content.Find.area',
    defaultMessage: 'Area',
  },
  'Colleagues.Content.Find.desk': {
    id: 'Colleagues.Content.Find.desk',
    defaultMessage: 'Desk',
  },
  'Colleagues.Content.Find.available_desks': {
    id: 'Colleagues.Content.Find.available_desk',
    defaultMessage: 'Available desks',
  },
});

export default {
  ...dictionary,
};
